import { TSP_CUSTOM_ROLE_ID_RANGE, TSP_ROLE_ID_RANGE, UserRole } from '@ti/contracts'

export const isTspRole = (roleId: UserRole) => {
  return (
    (roleId >= TSP_ROLE_ID_RANGE[0] && roleId <= TSP_ROLE_ID_RANGE[1]) ||
    (roleId >= TSP_CUSTOM_ROLE_ID_RANGE[0] && roleId <= TSP_CUSTOM_ROLE_ID_RANGE[1])
  )
}
